<div class="snackbar-content flex flex-col rounded-md shadow-lg min-w-64 max-w-md border-0 border-none outline-none overflow-hidden relative"
     [ngClass]="{
       'bg-green-600': data.type === 'success',
       'bg-red-600': data.type === 'error'
     }"
     [@slideInOut]="animationState"
     style="border: none; outline: none;">
  
  <!-- Progress bar -->
  <div *ngIf="data.duration" class="h-1 bg-white/30 w-full relative">
    <div class="h-full bg-white/70 absolute left-0 top-0" 
         [style.width.%]="progressValue"
         [@progressAnimation]="{ value: '*', params: { duration: data.duration }}"></div>
  </div>
  
  <!-- Content -->
  <div class="flex items-center justify-between p-4 text-white">
    <div class="flex items-center gap-3">
      <mat-icon class="text-white">
        {{ data.type === 'success' ? 'check_circle' : 'error' }}
      </mat-icon>
      <span class="text-sm font-medium">{{ data.message }}</span>
    </div>
    
    <div class="flex items-center">
      <button 
        mat-icon-button
        class="ml-1 text-white hover:bg-white/10 rounded-full h-8 w-8 flex items-center justify-center"
        (click)="dismiss()">
        <mat-icon class="text-sm">close</mat-icon>
      </button>
    </div>
  </div>
</div>